import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchData } from './config'

interface sweepstakes {
  links: any
  qr: any
  qrbw: any
  numberOfWinners: any
  status: any
  flyerES: any
  flyerEN: any
  id_brand: any
}

const initialState: sweepstakes = {
  links: [],
  qr: [],
  qrbw: [],
  numberOfWinners: 1,
  status: '',
  flyerES: '',
  flyerEN: '',
  id_brand: ''
}

export const getLinks = createAsyncThunk<any>('sweepatakes/links', async () => {
  const response = await fetchData().get('/api/purls-sweepstakes/get/FWY/links')
  const { data } = (await response).data
  return data
})

export const getQr = createAsyncThunk<any>('sweepatakes/qr', async () => {
  const response = await fetchData().get('/api/purls-sweepstakes/get/FWY/png/en/one')
  const { data } = (await response).data
  return data
})

export const getQrBW = createAsyncThunk<any>('sweepatakes/qrbw', async () => {
  const response = await fetchData().get('/api/purls-sweepstakes/get/FWY/png/en/one-bw')
  const { data } = (await response).data
  return data
})

const sweepstakesSlice = createSlice({
  name:'sweepstakes',
  initialState,
  reducers:{
    changeNumbersOfWinners: (state, {payload}) =>{
      state.numberOfWinners = payload
    }
  },
  extraReducers:(builder)=>{
    builder.addCase(getLinks.fulfilled, (state, {payload}) => {
      state.links = payload
      state.status = 'getDetailCampaign_success'
      state.id_brand = payload.brand.id_encrypted
    })
    builder.addCase(getLinks.pending, (state, {payload}) => {
      state.status = 'getDetailCampaign_loading'
    })
    builder.addCase(getQr.fulfilled, (state, {payload}) => {
      state.qr = payload
    })
    builder.addCase(getQrBW.fulfilled, (state, {payload}) => {
      state.qrbw = payload
    })
  }
})

export default sweepstakesSlice.reducer
export const { changeNumbersOfWinners } = sweepstakesSlice.actions;